import type { SVGProps } from "react";
// generated from Bell.svg — do not edit manually
// prettier-ignore
export default function Bell(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 19 18 V 9 C 19 5.134 15.866 2 12 2 C 8.134 2 5 5.134 5 9 V 18 M 19 18 H 5 M 19 18 H 21 M 5 18 H 3 M 9 18 V 19 C 9 20.657 10.343 22 12 22 C 13.657 22 15 20.657 15 19 V 18" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
